import { useRef, useState } from "react";
import { QrCode, Download } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";

export function CarQrButton({ car, variant = "icon" }) {
    const [open, setOpen] = useState(false);
    const canvasRef = useRef(null);
    const link = `${window.location.origin}/revision-conductor?car_id=${car.id}`;

    const download = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        a.download = `qr-${car.plate}.png`;
        a.click();
    };

    return (
        <>
            {variant === "icon" ? (
                <button
                    type="button"
                    onClick={() => setOpen(true)}
                    className="p-1.5 rounded hover:bg-slate-100"
                    title="Ver/Descargar QR"
                    data-testid={`qr-car-${car.id}`}
                >
                    <QrCode size={14} />
                </button>
            ) : (
                <Button type="button" variant="outline" onClick={() => setOpen(true)} className="gap-2" data-testid={`qr-car-${car.id}`}>
                    <QrCode size={16} /> Ver QR
                </Button>
            )}
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="max-w-sm" data-testid={`qr-dialog-${car.id}`}>
                    <DialogHeader>
                        <DialogTitle className="font-display">QR — {car.plate}</DialogTitle>
                    </DialogHeader>
                    <div className="flex flex-col items-center gap-3 py-2">
                        <QRCodeCanvas ref={canvasRef} value={link} size={220} marginSize={2} />
                        <p className="text-xs text-slate-500 text-center break-all">{link}</p>
                        <p className="text-xs text-slate-400 text-center">
                            Pega este código en el auto {car.plate} para que el conductor escanee y llene la revisión directamente para esta unidad.
                        </p>
                    </div>
                    <DialogFooter>
                        <Button onClick={download} className="bg-slate-900 hover:bg-slate-800 text-white w-full gap-2" data-testid={`qr-download-${car.id}`}>
                            <Download size={16} /> Descargar QR
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
}
